import { Image } from '@cian/ui-kit/image';
import React from 'react';

import { IMedia } from '../../../../../shared/components/Carousel';
import styles from './Thumbnail.css';

interface IThumbnailProps {
  media: IMedia | null;
}

export const Thumbnail: React.FC<IThumbnailProps> = ({ media, children }) => {
  return (
    <div className={styles['thumbnail']}>
      <Image src={media ? media.src : ''} objectFit="cover" />
      {children}
    </div>
  );
};
